var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data)?_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.html)}})]):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }